export const putStatusWorkCenterState = {
	workCenters: null,
	error: null,
	errorShow: false,
	loading: false,
};
